import { CountryAlpha2, CountryAlpha3, Province, Region } from '@nemuru-eng/js-api-client';

import { Geocode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/types';
import { postalCodeValidation } from '@/utils/zodUtils';

export const geocoderToAddressFieldsMapper = (geocode: Geocode) => {
  const get = (types: string[]) =>
    geocode.address_components.find((component) => component.types.find((type) => types.includes(type)));

  const streetName = get(['route', 'street_address', 'premise'])?.long_name ?? '';
  const streetNumber = get(['street_number'])?.long_name ?? '';
  const postalCode = get(['postal_code'])?.long_name ?? '';
  const postalCodeSuffix = get(['postal_code_suffix'])?.long_name ?? '';
  const city = get(['locality', 'postal_town', 'administrative_area_level_3'])?.long_name;
  const country = get(['country'])?.short_name ?? '';
  const countryLongName = get(['country'])?.long_name ?? '';

  const validPostalCode =
    country && postalCode ? postalCodeValidation(country as CountryAlpha2 | CountryAlpha3, postalCode) : false;

  const province =
    get(['administrative_area_level_2'])?.long_name ??
    (country === 'ES' && validPostalCode ? Province.createFromPostalCode(postalCode).longName : '');
  const provinceShortName =
    get(['administrative_area_level_2'])?.short_name ??
    (country === 'ES' && validPostalCode ? Province.createFromPostalCode(postalCode).shortName : '');
  const region =
    get(['administrative_area_level_1'])?.long_name ??
    (country === 'ES' && validPostalCode ? Region.createFromPostalCode(postalCode).longName : '');
  const regionShortName =
    get(['administrative_area_level_1'])?.short_name ??
    (country === 'ES' && validPostalCode ? Region.createFromPostalCode(postalCode).shortName : '');

  const latitude = geocode.geometry.location.lat() ?? '';
  const longitude = geocode.geometry.location.lng() ?? '';

  return {
    streetName,
    streetNumber,
    postalCode: `${postalCode}${postalCodeSuffix ? `${postalCodeSuffix}` : ''}`,
    city,
    province,
    provinceShortName,
    region,
    regionShortName,
    country,
    countryLongName,
    latitude,
    longitude,
  };
};
